module.exports = __webpack_public_path__ + "289c4ffe31e0b84ecfc69e42d91bda6b.svg";